<simple-notifications></simple-notifications>
<ion-app>
  @if (isUserLoggedIn) {
    <sm-header-title id="main-menu"></sm-header-title>
  }
  @if (isUserLoggedIn) {
    <sm-breadcrumb></sm-breadcrumb>
  }
  <ion-content>
    <ion-router-outlet class="pl-3" id="main-content"></ion-router-outlet>
  </ion-content>

  @if (isUserLoggedIn) {
    <ion-menu #userMenu class="main-menu" contentId="main-menu" type="overlay">
      <div class="d-flex flex-column justify-content-between full-menu">
        <div class="p-4">
          <ion-menu-toggle (click)="navigateToSchedule()" class="d-flex align-items-center py-3" type="button">
            <span class="material-symbols-outlined mr-2">calendar_today</span>
            <span>Surveys</span>
          </ion-menu-toggle>
          <ion-menu-toggle class="d-flex align-items-center py-3" routerLink="/settings" type="button">
            <span class="material-symbols-outlined mr-2">settings</span>
            <span>Settings</span>
          </ion-menu-toggle>
        </div>
        <div class="p-4">
          <hr>
            <div class="d-flex align-items-center py-3">
              <span class="sm-bg-warning-400 sm-text-white-600 rounded-circle mr-2 user-icon text-center align-middle">{{ userName | initials }}</span>
              <span>{{ userName }}</span>
            </div>
            <ion-menu-toggle (click)="logout()" class="d-flex align-items-center py-3" type="button">
              <span class="material-symbols-outlined mr-2">input</span>
              <span>Log Out</span>
            </ion-menu-toggle>
          </div>
        </div>
      </ion-menu>
    }
  </ion-app>
  @if (showSpinner) {
    <div class="block-ui">
      <ion-spinner></ion-spinner>
    </div>
  }
  <sm-library-styling></sm-library-styling>
